export const CAMPAIGN_SUBMISSIONS_LIST = '/v1/campaign-submissions';
export const CAMPAIGN_SUBMISSION_DETAILS = '/v1/campaign-submissions/';
export const APP_SUMO_CODES = '/appsumo/appsumocodes';
export const GENERATE_CLP_MEDIA_PRESIGNED_URL = '/v1/media-submissions/clp';
export const VIDEO_LANDING_PAGE_DATA = '/v1/video-landing';
export const UPLOAD_ASSETS = '/v1/asset-uploads'



// WEBPACK FOOTER //
// ./src/hooks/react-query/queries.js